import { render } from "./CulturaPage.vue?vue&type=template&id=5375145e&scoped=true"
import script from "./CulturaPage.vue?vue&type=script&lang=js"
export * from "./CulturaPage.vue?vue&type=script&lang=js"

import "./CulturaPage.vue?vue&type=style&index=0&id=5375145e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5375145e"]])

export default __exports__